export enum SERVICE {
  SELESFORCE = 'salesforce',
}
